import { Link } from 'react-router-dom';
import { Mail, MapPin, Building2, Shield, Leaf, Users } from 'lucide-react';

export default function ChiSiamo() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Chi siamo</div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tighter">La terra incontra le persone.</h1>
      <p className="mt-6 text-lg text-muted-foreground leading-relaxed max-w-2xl">
        AgriNexus è la piattaforma AgriTech che digitalizza la compravendita e l'affitto di terreni agricoli in Italia, unendo dati satellitari, intelligenza artificiale e uno sguardo umano al mondo della terra.
      </p>

      <div className="mt-8 rounded-2xl border-2 border-chartreuse/40 bg-chartreuse/5 p-6 max-w-2xl">
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-chartreuse mb-2">Fase Beta · Servizio Gratuito</div>
        <h2 className="font-display text-xl mb-2">Perché è gratis (per ora)</h2>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Siamo in fase di lancio e stiamo costruendo la migliore community di agricoltori e proprietari di terreni in Italia. Per farlo abbiamo scelto di rendere AgriNexus <strong>completamente gratuito</strong>: nessuna commissione, nessun abbonamento, nessun costo di pubblicazione. In futuro introdurremo funzionalità premium opzionali, ma le funzionalità principali resteranno gratuite.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-16">
        <div className="rounded-2xl border border-border p-6">
          <Leaf className="text-chartreuse mb-3" size={22}/>
          <h3 className="font-display text-lg mb-2">La nostra missione</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">Rendere l'accesso alla terra agricola trasparente, veloce e sicuro. Dare a ogni agricoltore, giovane investitore o famiglia lo stesso livello di informazione degli operatori professionali.</p>
        </div>
        <div className="rounded-2xl border border-border p-6">
          <Users className="text-chartreuse mb-3" size={22}/>
          <h3 className="font-display text-lg mb-2">Per chi lavoriamo</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">Proprietari che vogliono valorizzare la propria terra. Agricoltori in cerca di nuovi terreni. Giovani che tornano in campagna. Investitori attenti a valori reali e sostenibili.</p>
        </div>
        <div className="rounded-2xl border border-border p-6">
          <Shield className="text-chartreuse mb-3" size={22}/>
          <h3 className="font-display text-lg mb-2">I nostri principi</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">Trasparenza radicale sui dati. Tecnologia al servizio delle persone. Nessuna vendita di dati personali. AI come supporto, mai come sostituzione dell'esperto umano.</p>
        </div>
      </div>

      <div className="mt-20 rounded-2xl border border-border p-6 md:p-10 bg-secondary/30">
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-terracotta mb-3">Dati aziendali</div>
        <h2 className="font-display text-2xl mb-6">Titolare del sito e riferimenti legali</h2>
        <div className="grid md:grid-cols-2 gap-6 text-sm">
          <div className="flex items-start gap-3">
            <Building2 className="text-muted-foreground shrink-0 mt-0.5" size={18}/>
            <div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest">Denominazione</div>
              <div className="font-medium mt-1">AgriNexus</div>
              <div className="text-xs text-muted-foreground mt-1">Persona fisica / Società (in fase di costituzione)</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <MapPin className="text-muted-foreground shrink-0 mt-0.5" size={18}/>
            <div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest">Sede</div>
              <div className="font-medium mt-1">Italia</div>
              <div className="text-xs text-muted-foreground mt-1">Indirizzo completo comunicato su richiesta</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Mail className="text-muted-foreground shrink-0 mt-0.5" size={18}/>
            <div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest">Contatto principale</div>
              <a href="mailto:info@agrinexus.it" className="font-medium mt-1 link-underline block">info@agrinexus.it</a>
              <div className="text-xs text-muted-foreground mt-1">Risposte entro 48h lavorative</div>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <Shield className="text-muted-foreground shrink-0 mt-0.5" size={18}/>
            <div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest">P.IVA / REA / PEC</div>
              <div className="font-medium mt-1">In fase di attivazione</div>
              <div className="text-xs text-muted-foreground mt-1">Verranno pubblicati non appena disponibili</div>
            </div>
          </div>
        </div>
        <p className="text-xs text-muted-foreground mt-6 leading-relaxed">
          AgriNexus opera come <strong>portale annunci</strong> e non svolge attività di mediazione immobiliare ai sensi della L. 39/1989. Non partecipa alle trattative economiche tra le parti né percepisce commissioni sulle transazioni concluse.
        </p>
      </div>

      <div className="mt-12 text-sm text-muted-foreground flex flex-wrap gap-4">
        <Link className="link-underline" to="/contatti">Contatti →</Link>
        <Link className="link-underline" to="/privacy">Privacy →</Link>
        <Link className="link-underline" to="/termini">Termini →</Link>
      </div>
    </div>
  );
}
